"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var framer_motion_1 = require("framer-motion");
var styles_2 = require("../styles");
var checkbox_styles_1 = require("./checkbox_styles");
var merge_1 = __importDefault(require("lodash/merge"));
var useStyles = styles_1.makeStyles(checkbox_styles_1.styles);
var CheckboxComponent = react_1.forwardRef(function (_a, ref) {
    var _b = _a.component, Component = _b === void 0 ? framer_motion_1.motion.div : _b, checked = _a.checked, disabled = _a.disabled, color = _a.color, propsDefaultColor = _a.defaultColor, className = _a.className, inputClassName = _a.inputClassName, containerProps = _a.containerProps, onChange = _a.onChange, variant = _a.variant, isRadio = _a.isRadio, _c = _a.customClasses, oldCustomClasses = _c === void 0 ? {} : _c, _d = _a.classes, receivedClasses = _d === void 0 ? {} : _d, other = __rest(_a, ["component", "checked", "disabled", "color", "defaultColor", "className", "inputClassName", "containerProps", "onChange", "variant", "isRadio", "customClasses", "classes"]);
    var theme = styles_1.useTheme();
    var mergedClasses = react_1.useMemo(function () { return merge_1.default({}, oldCustomClasses, receivedClasses); }, [
        JSON.stringify(oldCustomClasses),
        JSON.stringify(receivedClasses),
    ]);
    var classes = useStyles({ classes: mergedClasses });
    var hexColor = react_1.useMemo(function () { return styles_2.getHexFromTheme(theme, color); }, [theme, color]);
    var defaultColor = react_1.useMemo(function () { return propsDefaultColor || (variant === 'raised' && '#fff') || styles_2.getHexFromTheme(theme, 'dark', 500); }, [propsDefaultColor, theme]);
    var colorMotion = {
        color: styles_2.getComponentColor(checked, hexColor !== null && hexColor !== void 0 ? hexColor : null, disabled, defaultColor),
    }.color;
    var handleChange = react_1.useCallback(function (event) {
        if (disabled) {
            return;
        }
        if (typeof onChange === 'function') {
            onChange(event);
        }
    }, [disabled, onChange]);
    return (react_1.default.createElement(Component, __assign({ className: classnames_1.default(classes.container, disabled && classes.disabled, isRadio && classes.isRadio, variant && classes[variant], className) }, containerProps, { style: __assign({}, (containerProps && containerProps.style)), animate: { color: colorMotion }, initial: "initial", whileHover: "hover" }, { ref: ref }),
        react_1.default.createElement(CheckIcon, __assign({}, { checked: checked, classes: classes })),
        react_1.default.createElement(framer_motion_1.motion.div, { className: classes.brightLayer, variants: { initial: { opacity: 0 }, hover: { opacity: 0.3 } } }),
        react_1.default.createElement("input", __assign({ className: classnames_1.default(classes.input, inputClassName), type: "checkbox", onChange: handleChange }, { checked: checked }, other))));
});
var DEFAULT_ICON_PROPS = {
    scale: 0.5,
    opacity: 0,
};
var CHECKED_ICON_PROPS = {
    scale: 1,
    opacity: 1,
};
var CheckIcon = function (_a) {
    var checked = _a.checked, classes = _a.classes;
    return (react_1.default.createElement(framer_motion_1.motion.svg, { className: classes.checkIcon, viewBox: "0 0 24 24", fill: "#fff", animate: checked ? CHECKED_ICON_PROPS : DEFAULT_ICON_PROPS, transition: { type: 'spring', bounce: 0.6 } },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }))));
};
exports.Checkbox = CheckboxComponent;
